<template>
  <div class="container">
    <div class="body">
      <div class="wrap">
        <p class="wrapTitle clear">新闻中心</p>
        <p class="wrapDesc clear">NEWS CENTER</p>
        <p
          class="wrapMore clear"
          @click="toMore('https://www.anquanke.com/subject.html?id=289102')"
        >
          了解更多<right-outlined />
        </p>
        <div class="wrapHot">
          <img class="wrapHotImg" :src="activeImg" alt="热点新闻" />
          <div class="wrapHotNav">
            <p class="wrapHotNavTitle clear">{{ newsList[pitchId].title }}</p>
            <p class="wrapHotNavDesc clear">
              {{ newsList[pitchId].desc }}
            </p>
            <p class="wrapHotNavMore clear" @click="toMore(newsList[pitchId].url)">
              查看详情<right-outlined />
            </p>
          </div>
        </div>
        <div class="wrapNum">
          {{ pitchId + 1 }}
          <p class="wrapNumLen">/3</p>
        </div>
        <Btn :navArr="newsList" :stopId="3" :style="styleBtn" @fetchNav="fetchNav" />
      </div>
    </div>
    <ul class="news" v-if="newsList && newsList[2]">
      <li class="newsList" v-for="index in 3" :key="index">
        <p class="newsListTitle clear">{{ newsList[2 + index].title }}</p>
        <p class="newsListDesc clear">{{ newsList[2 + index].desc }}</p>
        <p class="newsListCreatedAt clear">
          <TimeIcon type="icon-shijian" />
          {{ newsList[2 + index].createdAt }}
        </p>
        <p class="newsListMore clear" @click="toMore(newsList[2 + index].url)">
          查看详情<right-outlined />
        </p>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { RightOutlined, createFromIconfontCN } from '@ant-design/icons-vue'
import { getIscNews } from '@/api/2023/index.js'
import { ref, onBeforeMount, watch } from 'vue'
import Btn from '@/components/common/2023/button.vue'
const TimeIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4109126_i6x3sy4e4hr.js'
})
const styleBtn = {
  position: 'absolute',
  right: '0px',
  top: '530px'
}
const topicId = 289102
const newsList = ref([
  {
    cover: '', // 封面图地址
    createdAt: '', // 发布时间
    desc: '', // 描述
    title: '', //标题
    url: '' //链接
  }
])
const pitchId = ref(0)
const activeImg = ref('')

onBeforeMount(async () => {
  await fetch()
})
watch(pitchId, () => fetchImg())
function fetchImg() {
  const img = newsList.value[pitchId.value].cover.split('/sdm/229_160_100')
  activeImg.value = img[0] + img[1]
}
function fetch() {
  getIscNews(topicId)
    .then((res) => {
      //成功后的操作...
      newsList.value = res.data.data.list
      fetchImg()
    })
    .catch((err) => {
      //失败后的操作...
      console.log('失败', err)
    })
}
function toMore(url) {
  window.open(url)
}
function fetchNav(newId) {
  pitchId.value = newId
}
</script>

<style lang="scss" scoped>
.clear {
  margin: 0;
}
.body {
  height: 715px;
  background: url('https://p2.ssl.qhimg.com/t01d35747cab15e5007.png') no-repeat center;
  padding: 32px 15px;
}
.wrap {
  position: relative;
  margin: auto;
  &Title {
    font-size: 18px;
    font-weight: bold;
    line-height: 28px;
    color: #00ab7a;
  }
  &Desc {
    font-size: 12px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 20px;
  }
  &More {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 2px;
    color: #00ab7a;
    background-color: transparent;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
    width: 96px;
    height: 32px;
    border: 1px solid #00ab7a;
  }
  &Hot {
    position: relative;
    &Img {
      width: 100%;
      // width: 384px;
      // height: 238px;
    }
    &Nav {
      position: relative;
      padding: 8px 16px 0;
      widows: 100%;
      // width: 384px;
      height: 204px;
      background: #ffffff;
      border: 1px solid #e8e8e8;
      box-shadow: 0px 4px 10px 0px rgba(0, 31, 138, 0.15);
      &More {
        position: absolute;
        right: 16px;
        bottom: 24px;
        font-size: 14px;
        line-height: 24px;
        color: #00ab7a;
        margin: 0;
      }
      &Title {
        font-weight: bold;
        font-size: 16px;
        line-height: 32px;
        color: #3d3d3d;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &Desc {
        font-size: 14px;
        line-height: 28px;
        color: #666666;
        margin-top: 6px;
      }
    }
  }
  &Num {
    font-size: 24px;
    color: #fff;
    margin: 0;
    &Len {
      display: inline-block;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
.news {
  position: relative;
  background-color: rgb(247, 248, 252);
  margin: auto;
  &List {
    top: -40px;
    width: 380px;
    height: 213px;
    padding: 23px 18px;
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
    list-style: none;
    color: #3d3d3d;
    margin: auto;
    &Title {
      font-size: 16px;
      line-height: 32px;
      color: #3d3d3d;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &Desc {
      height: 84px;
      font-size: 14px;
      line-height: 28px;
      color: #666666;
      margin: 8px 0 12px;
      overflow: hidden;
    }
    &CreatedAt {
      font-size: 12px;
      line-height: 32px;
      color: #8a9099;
      img {
        margin-right: 9px;
      }
    }
    &More {
      position: absolute;
      right: 18px;
      bottom: 26px;
      font-size: 14px;
      line-height: 24px;
      color: #00ab7a;
      margin: 0;
    }
  }
  &List:last-child {
    border: 0;
  }
}
</style>
